/* ════ DRAW TO CREATE ══════════════════════════════════════ */
import { state } from '../state.js';
import { $ } from '../dom.js';
import { MO } from '../config.js';
import { addD, ddiff } from '../utils/date.js';
import { halfRangeToDates } from './util.js';
import { openNew } from '../modals/task.js';
import { buildGantt } from './index.js';
import { suppressClick } from './dragguard.js';

export function setupDraw(sec, resId) {
  sec.addEventListener('mousedown', e => {
    if (e.target.closest('.task-block')) return;
    e.preventDefault();
    const ts = $('tl-scroll'), tip = $('snap-tip');
    const HW = () => state.DAY_W / 2;
    const contentX = clientX => clientX - ts.getBoundingClientRect().left + ts.scrollLeft;
    const halfAt = clientX => Math.max(0, Math.round(contentX(clientX) / HW()));

    // Anchor the start to an absolute date so paging the view doesn't move it.
    const startH = halfAt(e.clientX);
    const startDate = addD(state.viewStart, Math.floor(startH / 2));
    const startPM = startH % 2 === 1;
    const startHalfRel = () => ddiff(state.viewStart, startDate) * 2 + (startPM ? 1 : 0);

    let lastX = e.clientX, lastY = e.clientY, pageTimer = null, pageDir = 0;

    const draw = () => {
      const ghost = $(`g-${resId}`); if (!ghost) return;
      const hw = HW();
      const cur = halfAt(lastX), sRel = startHalfRel();
      const mh = Math.min(sRel, cur), xh = Math.max(sRel, cur);
      ghost.className = `draw-ghost ${state.selCat}`;
      ghost.style.cssText = `display:block;left:${mh * hw}px;top:7px;width:${(xh - mh + 1) * hw - 2}px;height:${state.LANE_H - 14}px`;
      const fd = addD(state.viewStart, Math.floor(mh / 2)), td = addD(state.viewStart, Math.floor(xh / 2));
      tip.textContent = `${fd.getDate()} ${MO[fd.getMonth()]}${mh % 2 ? ' PM' : ''} → ${td.getDate()} ${MO[td.getMonth()]}${xh % 2 ? ' AM' : ''}`;
      tip.style.left = (lastX + 14) + 'px'; tip.style.top = (lastY - 30) + 'px'; tip.classList.add('show');
    };
    // Page the view in time while drawing at an edge.
    const tick = () => { state.viewStart = addD(state.viewStart, pageDir); buildGantt(); draw(); };
    const edgeCheck = () => {
      const r = ts.getBoundingClientRect(), M = 56;
      const dir = lastX > r.right - M ? 1 : (lastX < r.left + M ? -1 : 0);
      if (dir !== pageDir) {
        pageDir = dir;
        if (pageTimer) { clearInterval(pageTimer); pageTimer = null; }
        if (dir) pageTimer = setInterval(tick, 90);
      }
    };

    draw();
    const onMove = ev => { lastX = ev.clientX; lastY = ev.clientY; draw(); edgeCheck(); };
    const onUp = ev => {
      document.removeEventListener('mousemove', onMove); document.removeEventListener('mouseup', onUp);
      if (pageTimer) { clearInterval(pageTimer); pageTimer = null; }
      tip.classList.remove('show'); suppressClick();
      lastX = ev.clientX;
      const cur = halfAt(lastX), sRel = startHalfRel();
      const mh = Math.min(sRel, cur), xh = Math.max(sRel, cur);
      const ghost = $(`g-${resId}`); if (ghost) ghost.style.display = 'none';
      // [mh, xh] inclusive selection → exclusive right boundary xh+1.
      const { start, end, half } = halfRangeToDates(mh, xh + 1);
      openNew(start, end, resId, half);
    };
    document.addEventListener('mousemove', onMove); document.addEventListener('mouseup', onUp);
  });
}
